export enum EP {
    API = 'api',
    V1 = 'v1',
    CALCULATE = 'calculate',
    SHIP = 'ship',
    CART = 'cart',
    SHOP = 'shop',
    DETAIL = 'detail',
    USERNAME = 'username',
    DOMAIN = 'domain',
    CATEGORY = 'category',
    PRODUCT = 'product',
    INFO = 'info',
    LIST = 'list',
    PAYMENT = 'payment',
    TYPE = 'type',
    AFFILIATE = 'affiliate',
    DROPSHIP = 'dropship',
    METHOD = 'method',
    PROVINCEID = 'province_id',
    DISTRICTID = 'district_id',
    ORDER = 'order',
    CREATE = 'create',
    ADDRESS = 'address',
    PROVINCE = 'province',
    DISTRICT = 'district',
    WARD = 'ward',
    CONFIG = 'config',
    FILE = 'file',
    PROVINCEJSON = 'province.json',
    STORE = 'store',
    CATE = 'cate',
    CREATEORDER = 'createOrder',
    CALCULATORDISCOUNT = 'calculatorDiscount',
    CREATECARTPRODUCT = 'createCartProduct',
    ID = 'id',
    DETAILPRODUCT = 'detailproduct',
    SLUG = 'slug',
    COMBO = 'combo'
}